import { IsInt, IsOptional, IsString, MaxLength, IsNumber, IsBoolean, Length } from 'class-validator';

export class WidgetUpdateRequest {
    @IsOptional()
    @IsInt()
    public id?: number;

    @IsString()
    @MaxLength(255)
    public name?: string;

    @IsString()
    @MaxLength(255)
    public domain?: string;

    @IsNumber()
    public contragentId?: number;

    @IsString()
    @Length(36, 36)
    public nomPosUuId: string;

    @IsBoolean()
    public status?: boolean;

    constructor(data?: Partial<WidgetUpdateRequest>) {
        this.id = data?.id;
        this.name = data?.name;
        this.domain = data?.domain;
        this.contragentId = data?.contragentId;
        this.nomPosUuId = data?.nomPosUuId;
        this.status = data?.status;
    }
}
